import { c as _c } from "react/compiler-runtime";
import type { ComponentType } from 'react';
import { isUnknownModel } from './ai-attribution-utils';
import { getToolDisplayName } from '@/lib/analytics/chart-colors';
type AiAttributionToolRowProps = {
  tool: string;
  model: string | null;
  percent: number | null;
  /** Subtle qualifier after the name, e.g. "likely" for a non-certain marker match. */
  tag?: string | null;
  ToolIcon: ComponentType<{
    size: number;
  }>;
  ModelIcon: ComponentType<{
    size: number;
  }> | null;
};
export function AiAttributionToolRow(t0) {
  const $ = _c(22);
  const {
    tool,
    model,
    percent,
    tag,
    ToolIcon,
    ModelIcon
  } = t0;
  let t1;
  if ($[0] !== model) {
    t1 = model !== null && !isUnknownModel(model);
    $[0] = model;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hasModel = t1;
  let t2;
  if ($[2] !== ToolIcon) {
    t2 = <ToolIcon size={14} />;
    $[2] = ToolIcon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== tool) {
    t3 = getToolDisplayName(tool);
    $[4] = tool;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <span className="text-zinc-300">{t3}</span>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== ModelIcon || $[9] !== hasModel || $[10] !== model) {
    t5 = hasModel ? <><span className="text-zinc-600">/</span>{ModelIcon ? <ModelIcon size={14} /> : null}<span className="min-w-0 truncate">{model}</span></> : null;
    $[8] = ModelIcon;
    $[9] = hasModel;
    $[10] = model;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== tag) {
    t6 = tag ? <span className="rounded-sm border border-zinc-800 px-1 text-[10px] leading-4 text-zinc-500">{tag}</span> : null;
    $[12] = tag;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== percent) {
    t7 = percent !== null ? <span className="ml-auto shrink-0 tabular-nums text-zinc-500">{`${percent}%`}</span> : null;
    $[14] = percent;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t2 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t8 = <div className="flex items-center gap-1.5 text-[11px] text-zinc-400">{t2}{t4}{t5}{t6}{t7}</div>;
    $[16] = t2;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}